import {
  UPDATE_AGREED_TO_TERMS,
  UPDATE_CONTACT,
  UPDATE_LOADER,
  UPDATE_MODAL_TO_SHOW,
  UPDATE_PLAN_DETAILS,
  UPDATE_PROVINCE,
  UPDATE_RECAPTCHA,
} from './dispatch-actions';

import { reducerFactory } from '../helpers/common-helper';

import {
  updatContactHandler,
  updateAgreedToTermsHandler,
  updateLoaderHandler,
  updateModalToShowHandler,
  updatePlanDetailsHandler,
  updateProvinceHandler,
  updateRecaptchaHandler,
} from './handlers';
import getContactInitialState from '../helpers/contact-helper';
import {
  isAnsweringServiceBrand,
  isCanadaBrand,
  isChatSupportBrand,
  isSetmoreStartNowPage,
  isTaxApplicable,
} from '../helpers/brands';

function getPlanDetailsInitialState() {
  let initialState = {
    selectedPlanId: undefined,
    totalAmount: 0,
    freeTrial: false,
    ...(isTaxApplicable && { taxPercentage: 0 }),
  };

  if (isAnsweringServiceBrand) {
    initialState = {
      ...initialState,
      selectedIVRId: undefined,
      selectedAddons: undefined,
    };
  }

  return initialState;
}

export const signupInitialState = {
  planDetails: getPlanDetailsInitialState(),
  contact: getContactInitialState(),
  loader: false,
  agreedToTerms: { agreed: !!isChatSupportBrand || isSetmoreStartNowPage(), showToolTip: false },
  modalToBeShown: {
    view: undefined, message: undefined, editPlan: false,
  },
  recaptcha: {
    checkBoxChecked: undefined,
    display: false,
    invisibleCaptchaFailed: false,
  },
  ...(isCanadaBrand && {
    province: {
      provinceCode: null,
      value: null,
      valid: undefined,
      disabled: false,
    },
  }),
};


export const signupReducer = reducerFactory(signupInitialState, {
  [UPDATE_PLAN_DETAILS]: updatePlanDetailsHandler,
  [UPDATE_CONTACT]: updatContactHandler,
  [UPDATE_LOADER]: updateLoaderHandler,
  [UPDATE_AGREED_TO_TERMS]: updateAgreedToTermsHandler,
  [UPDATE_MODAL_TO_SHOW]: updateModalToShowHandler,
  [UPDATE_RECAPTCHA]: updateRecaptchaHandler,
  ...(isCanadaBrand && { [UPDATE_PROVINCE]: updateProvinceHandler }),
});
